var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("CustomerList", {
    attrs: { "role-type": "clin-trans", title: "Clin-trans" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }